<template>
  <div class="cash-withdrawal">
    <!--
    <div class="nav acea-row">
      <div
        v-for="(item, index) in navList"
        class="item font-color-red"
        @click="swichNav(index, item)"
        :key="index"
      >
        <div
          class="line bg-color-red"
          :class="currentTab === index ? 'on' : ''"
        ></div>
        <div
          class="iconfont"
          :class="item.icon + ' ' + (currentTab === index ? 'on' : '')"
        ></div>
        <div>{{ item.name }}</div>
      </div>
    </div>
    -->
    <div class="wrapper">
      <div class="list">
        <el-form
          :model="post"
          :rules="rules"
          ref="post"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="醫生姓名" prop="real_name">
            <el-input
              v-model="post.real_name"
              placeholder="請輸入醫生姓名"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="全一编号"
            prop="doctor_id"
            v-if="userInfo.first_spread_uid"
          >
            <el-input
              v-model="post.doctor_id"
              placeholder="請輸入醫生编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手機號碼" prop="phone">
            <el-input
              v-model="post.phone"
              placeholder="請輸入醫生联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="所屬醫院" prop="hospital">
            <el-input
              v-model="post.hospital"
              placeholder="請輸入醫生所属医院"
            ></el-input>
          </el-form-item>
          <el-form-item label="所屬科室" prop="department">
            <el-input
              v-model="post.department"
              placeholder="請輸入醫生所属科室"
            ></el-input>
          </el-form-item>
          <el-form-item label="職位" prop="position">
            <el-input
              v-model="post.position"
              placeholder="請輸入醫生職位"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="學術研討費" prop="brokerage">
            <el-input
              v-model="post.brokerage"
              placeholder="請輸入學術研討費"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="所属科室" prop="department">
          <DepartmentHospital
            @department-val="departmentName"
            :departmentVal="ruleForm.department"
            :departmentOptions="departmentOptions"
          ></DepartmentHospital>
        </el-form-item> -->
        </el-form>
        <div class="bnt bg-color-red" @click="submit(post)">添加</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  /* getBank,  */ postCashInfo,
  addDoctor,
  getUserInfo
} from "@api/user";
//import { required } from "@utils/validate";
// import { validatorDefaultCatch } from "@utils/dialog";
// import axios from "axios";
// import { VUE_APP_API_URL, isWeixin } from "@utils";
export default {
  name: "UserCash",
  components: {},
  props: {},
  data: function() {
    return {
      post: {
        real_name: "",
        brokerage: "",
        hospital: "",
        phone: "",
        department: "",
        position: "",
        doctor_id: ""
      },
      rules: {
        real_name: [{ required: true, message: "請輸入名字", trigger: "blur" }],
        doctor_id: [{ required: true, message: "請輸入编号", trigger: "blur" }],
        phone: [
          { required: true, message: "請輸入手機號碼", trigger: "blur" },
          { min: 11, max: 11, message: "長度為11個數字", trigger: "blur" }
        ],
        hospital: [
          { required: true, message: "請輸入醫生所属医院", trigger: "blur" }
        ],
        department: [
          { required: true, message: "請輸入醫生所属科室", trigger: "blur" }
        ],
        position: [
          { required: true, message: "請輸入醫生職位", trigger: "blur" }
        ]
        // brokerage: [
        //   { required: true, message: "請輸入学术研讨费", trigger: "blur" }
        // ]
      },
      userInfo: {}
    };
  },
  mounted: function() {
    getUserInfo().then(res => {
      console.log("user");
      console.log(res);
      this.userInfo = res.data;
    });
  },
  methods: {
    checkPhone(phone) {
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        return false;
      } else {
        return true;
      }
    },
    submit: function(post) {
      let that = this;
      if (post.real_name == "") return this.$dialog.message("請輸入名字");
      if (post.phone == "") return this.$dialog.message("請輸入手機號碼");
      if (post.doctor_id == "" && this.userInfo.first_spread_uid == 1612)
        return this.$dialog.message("請輸入全一编号");
      if (!this.checkPhone(post.phone)) {
        return this.$dialog.message("手機號碼格式不正确");
      }
      if (post.department == "")
        return this.$dialog.message("請輸入醫生所屬部門");
      if (post.position == "") return this.$dialog.message("請輸入醫生職位");

      if (post.hospital == "")
        return this.$dialog.message("請輸入醫生所属医院");
      // if (post.brokerage == "") return this.$dialog.message("請輸入学术研讨费");
      addDoctor(post)
        .then(res => {
          console.log(res);
          that.$dialog.toast({
            mes: res.msg
          });
          setTimeout(() => {
            that.$router.push({
              path: `poster?uid=` + res.data.uid
            });
          }, 1000);
          //poster?uid=` + res.data.uid
          // that.$router.push({
          //     path: `/user/user_promotion`
          //   });
          //that.$router.push("/user/promoter_list");
        })
        .catch(err => {
          this.$dialog.toast({
            mes: err.msg
          });
        });
    },
    save: function(info) {
      postCashInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/audit" });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
